/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


$(document).ready(function() {
    $('<li><a target="_blank" href="https://anpc.ro/ce-este-sal/"><img src="https://cdn.shopify.com/s/files/1/0901/8939/8345/files/sal.png?v=1727780190" class="adjust-badges"></a></li><li><a target="_blank" href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=RO"><img src="https://cdn.shopify.com/s/files/1/0901/8939/8345/files/sol.png?v=1727780190" class="adjust-badges"></a></li>').insertAfter($('a[href^="/policies/legal-notice"]').parent());
});
